module.exports = __webpack_public_path__ + "static/media/mail.84733e50.svg";